import { Spinner } from '@/components/common/Spinner'

/** Inline waiting row shown while `useAccounts()` is in flight. */
export function LobbyLoading() {
  return (
    <div className="wsloading" role="status" aria-live="polite">
      <Spinner label="Loading your workspaces" />
      <span>Loading your workspaces&hellip;</span>
    </div>
  )
}
